<!-- 付款单信息 -->
<template>
  <base-form
    v-model="formData"
    :options="options"
    ref="formData"
    :disabled="!canEdit"
    @input="handleChange"
    label-width="100px"
  >
  </base-form>
</template>

<script>
  import BaseForm from '@/components/form/base-form';
  // import ajaxSelect from '@/components/form-item/ajax-select';
  import API from '@/api/financeCenter/payables';
  import DataBaseAPI from '@/api/dataBase';
  import PAYMENT_API from '@/api/financeCenter/paymentApply.js';
  import { mapState } from 'vuex';
  // import searchTable from '@/components/form-item/search-table';
  import { paymentClass } from '@/common/js/paymentMapping.js';
  import XEUtils from 'xe-utils';
  import { digitUppercase } from '@/common/js/util';
  export default {
    name: 'feeInfo',
    components: {
      BaseForm,
      // ajaxSelect,
      // searchTable,
    },

    props: [
      'companyList',
      'detail',
      'query',
      'canEdit',
      'feeInfo',
      'getPayapplyLine',
      'canEditSettlementBusinessType',
    ],
    computed: {
      ...mapState({
        requestPerson: (state) => state.userInfo.userInfo.userName, //申请人
        /*paymentTypeList(){
             let list = this.$baseRequest.getDictListByType("payment_type");
            if(list[0] && this.formData.sourceType=="INVOICE"){
              list = list.filter(it=>it.value!="PT03")
            }
            return paymentClass
          },*/
        currencyList() {
          return this.$baseRequest.getDictListByType('all_currency');
        },
      }),
      // 多联付款类别
      // 付款运输费用、考核费、服务或设备费、保证金、退保证金、法务费用、货款
      paymentTypeForMulti() {
        return [
          {
            value: 'PT13',
            label: '付款运输费用',
            paymentUsage: '购买商品',
          },
          {
            value: 'PT14',
            label: '考核费',
            paymentUsage: '其他',
          },
          {
            value: 'PT15',
            label: '服务或设备费',
            paymentUsage: '购买商品',
          },
          {
            value: 'PT05',
            label: '保证金',
            paymentUsage: '购买商品',
          },
          {
            value: 'PT10',
            label: '退保证金',
            paymentUsage: '其他',
          },
          {
            value: 'PT16',
            label: '法务费用',
            paymentUsage: '其他',
          },
          {
            value: 'PT01',
            label: '货款',
            paymentUsage: '购买商品',
          },
        ];
      },
      //顶部表单配置
      options() {
        // const data = this.formData;specialValidate

        // 校验特殊字符
        var specialValidate = (rule, value, callback) => {
          var p = /[:;,‘’%|；：”“\'。""，？\s+]/g;
          if (!value) {
            return callback(new Error('请输入摘要'));
          } else if (p.test(value)) {
            return callback(
              new Error('请不要输入特殊字符:;,‘’%|；：”“\'。""，？空格、制表符、换页符等')
            );
          } else {
            return callback();
          }
        };
        let list = [
          {
            type: 'select',
            options: this.companyList,
            label: this.$t('fundPaymentApply.column.requestCompanyCode'),
            prop: 'requestCompanyCode',
            clearable: true,
            disabled: !!this.feeInfo.isRelatedInstruction,
            required: true,
          }, //申请单公司代码
          {
            type: 'select',
            options: this.departmentList,
            label: this.$t('fundPaymentApply.column.requestDepartmentCode'),
            prop: 'requestDepartmentCode',
            clearable: true,
            disabled: !!this.feeInfo.isRelatedInstruction,
            required: true,
          }, //申请单部门代码
          {
            type: 'select',
            label: '业务类别',
            prop: 'settlementBusinessType',
            clearable: true,
            options: this.dictListMap.businessCategoryPayable,
            required: true,
            disabled: !!this.feeInfo.isRelatedInstruction || !this.canEditSettlementBusinessType,
          },
          {
            type: 'select',
            options:
              this.userInfo.businessGroup == '多式联运' &&
              this.formData.settlementBusinessTypeName == '多式联运'
                ? this.paymentTypeForMulti
                : this.paymentTypeList,
            label: this.$t('fundPaymentApply.column.paymentType'),
            prop: 'paymentType',
            clearable: true,
            disabled: false,
            required: true,
          }, //付款类别(字典)
          {
            type: 'dict',
            dictType: 'apply_payment_method',
            label: this.$t('fundPaymentApply.column.paymentMethod'),
            prop: 'paymentMethod',
            clearable: true,
            disabled: false,
            required: true,
          }, //付款方式(字典)
          // {
          //   type: 'searchTable',
          //   label: '信用证号',
          //   prop: 'clCode',
          //   searchType: 'LC',
          //   isMultiple: true,
          //   currentValue: this.formData.clCode,
          //   required:
          //     this.formData.paymentMethod &&
          //     ['016', '015'].indexOf(this.formData.paymentMethod) != -1
          //       ? true
          //       : false,
          //   disabled:
          //     !this.formData.paymentMethod ||
          //     this.formData.paymentMethod == '' ||
          //     ['016', '015', '10'].indexOf(this.formData.paymentMethod) == -1,
          //   getName: 'clCode',
          //   getCode: 'clCode',
          //   extraData: {
          //     sourceType: '1',
          //     statusFlags: ['005', '006', '007', '008'],
          //   },
          //   clearable: true,
          // }, //票据号
          // {
          //   type: 'searchTable',
          //   label: '票据号',
          //   prop: 'billNo',
          //   searchType: 'bill',
          //   currentValue: this.formData.billNo,
          //   isMultiple: true,
          //   clearable: true,
          //   getName: 'billCode',
          //   getCode: 'billCode',
          //   extraData:
          //     this.formData.paymentMethod == '10'
          //       ? {
          //           billCompanyCode: this.formData?.requestCompanyCode,
          //         }
          //       : {
          //           billType: '2',
          //           billCompanyCode: this.formData?.requestCompanyCode,
          //           // billStatus: '03',
          //         },
          //   required:
          //     this.formData.paymentMethod &&
          //     ['013', '012'].indexOf(this.formData.paymentMethod) != -1
          //       ? true
          //       : false,
          //   disabled:
          //     this.formData.requestCompanyCode == '' ||
          //     !this.formData.requestCompanyCode ||
          //     !this.formData.paymentMethod ||
          //     this.formData.paymentMethod == '' ||
          //     ['013', '012', '017', '10'].indexOf(this.formData.paymentMethod) == -1,
          // }, //票据号
          {
            type: 'searchTable',
            label: this.$t('fundPaymentApply.column.payeeNo'),
            prop: 'payeeNo',
            clearable: true,
            disabled: !!this.formData.isMoreDeliverer || !!this.feeInfo.isRelatedInstruction,
            required: !this.formData.isMoreDeliverer,
            isMultiple: true,
            searchType: 'supplier',
            name: 'payeeName',
            extraData: this.getPayeeData(),
            valueType: 'object',
            code: 'payeeNo',
            getName: 'partnerZhName',
            getCode: 'partnerCode',
          }, //收款单位
          {
            type: 'select',
            options: this.partnersBanks,
            label: this.$t('fundPaymentApply.column.bankNo'),
            prop: 'bankAccount',
            clearable: true,
            disabled: !!this.formData.isMoreDeliverer,
            required: !this.formData.isMoreDeliverer,
          }, //开户银行
          {
            type: 'input',
            label: this.$t('fundPaymentApply.column.bankAccount'),
            prop: 'bankAccount',
            clearable: true,
            disabled: true,
            required: !this.formData.isMoreDeliverer,
          }, //银行账号
          {
            type: 'input',
            label: this.$t('fundPaymentApply.column.bankUnionNumber'),
            prop: 'bankUnionNumber',
            clearable: true,
            disabled: true,
          }, //联行号
          {
            type: 'input',
            label: this.$t('fundPaymentApply.column.bankBranch'),
            prop: 'bankBranch',
            clearable: true,
            disabled: true,
          }, //开户分行
          {
            type: 'input',
            label: this.$t('fundPaymentApply.column.requestPersonName'),
            prop: 'requestPersonName',
            clearable: true,
            disabled: true,
          }, //申请人名称
          {
            type: 'input',
            label: '申请金额原币',
            prop: 'requestAmount',
            clearable: true,
            disabled: true,
            required: false,
          },
          {
            type: 'input',
            label: '申请金额原币',
            prop: 'requestAmountStr',
            clearable: true,
            disabled: true,
          },
          {
            type: 'input',
            label: '申请金额本位币',
            prop: 'requestAccountedAmount',
            clearable: true,
            disabled: true,
            required: false,
          }, //申请金额本位币 --必填
          {
            type: 'input',
            label: '申请金额本位币',
            prop: 'requestAccountedAmountStr',
            clearable: true,
            disabled: true,
          },
          {
            type: 'dict',
            label: this.$t('fundPaymentApply.column.currencyCode'),
            prop: 'currencyCode',
            clearable: true,
            dictType: 'all_currency',
            disabled: this.formData.sourceType == 'INVOICE',
            required: true,
          }, //币种编码
          {
            type: 'date',
            label: this.$t('fundPaymentApply.column.exchangeRateDate'),
            prop: 'exchangeRateDate',
            clearable: true,
            disabled: false,
            required: true,
          }, //汇率日期
          {
            type: 'dict',
            label: this.$t('fundPaymentApply.column.exchangeType'),
            prop: 'exchangeType',
            clearable: true,
            dictType: 'exchange_type',
            disabled: this.formData.sourceType == 'INVOICE',
            required: true,
            moreInput: true,
            moreProp: 'exchangeRate',
            ruleType: 'object',
            validatorKey: this.formData.exchangeRate,
            morePlaceholder: this.$t('fundPaymentApply.placeholder.exchangeRate'),
            moreClearable: true,
            moreRequired: true,
            moreDisabled: this.formData.exchangeType == 'Cooperate',
          }, //汇率类型 //汇率
          {
            type: 'input',
            label: this.$t('fundPaymentApply.column.paidAmount'),
            prop: 'paidAmount',
            clearable: true,
            disabled: true,
            required: false,
          }, //已付款金额原币 --必填
          {
            type: 'input',
            label: this.$t('fundPaymentApply.column.unpaidAmount'),
            prop: 'unpaidAmount',
            clearable: true,
            disabled: true,
            required: false,
          }, //未付款金额原币 --必填
          {
            type: 'input',
            label: this.$t('fundPaymentApply.column.unpaidAmount'),
            prop: 'unpaidAmountStr',
            disabled: true,
          },
          {
            type: 'input',
            label: this.$t('fundPaymentApply.column.paidAccountedAmount'),
            prop: 'paidAccountedAmount',
            clearable: true,
            disabled: true,
            required: false,
          }, //已付款金额本位币 --必填
          {
            type: 'input',
            label: this.$t('fundPaymentApply.column.unpaidAccountedAmount'),
            prop: 'unpaidAccountedAmount',
            clearable: true,
            disabled: true,
            required: false,
          }, //未付款金额本位币 --必填
          {
            type: 'input',
            label: this.$t('fundPaymentApply.column.unpaidAccountedAmount'),
            prop: 'unpaidAccountedAmountStr',
            disabled: true,
          },
          {
            type: 'input',
            label: this.$t('fundPaymentApply.column.paymentApplyNumber'),
            prop: 'paymentApplyNumber',
            clearable: true,
            disabled: true,
          }, //付款申请单号
          {
            type: 'date',
            label: this.$t('fundPaymentApply.column.requestDate'),
            prop: 'requestDate',
            clearable: true,
            disabled: true,
            required: true,
          }, //申请日期
          {
            type: 'date',
            label: this.$t('fundPaymentApply.column.gmtCreate'),
            prop: 'gmtCreate',
            clearable: true,
            disabled: true,
            required: false,
          }, //创建日期
          {
            type: 'dict',
            label: this.$t('fundPaymentApply.column.requestStatus'),
            prop: 'requestStatus',
            clearable: true,
            dictType: 'payment_apply_request_status',
            disabled: true,
          }, //单据状态
          {
            type: 'dict',
            label: this.$t('paymentApplyList.table.paymentStatus'),
            prop: 'paymentStatus',
            clearable: true,
            dictType: 'payment_status',
            disabled: true,
          }, //付款状态
          //  {type: 'input', label: this.$t('fundPaymentApply.column.availableCreditAmount'), prop: 'availableCreditAmount', clearable: true,disabled: true,required: this.formData.paymentType=='PT01'},//可用信用额度
          {
            type: 'input',
            label: '已付款比例',
            prop: 'paymentProportion',
            clearable: true,
            disabled: true,
            required: false,
          },
          {
            type: 'input',
            span: 24,
            maxlength: 20,
            label: '摘要',
            prop: 'summary',
            validator: specialValidate,
            clearable: true,
            disabled: false,
            required: true,
          }, //摘要
          {
            type: 'textarea',
            span: 24,
            maxlength: 600,
            label: '补充说明',
            prop: 'supplementary',
            // validator: specialValidate,
            clearable: true,
            disabled: false,
            required: false,
          }, //摘要

          //  {type: 'input', label: this.$t('fundPaymentApply.column.closeReason'), prop: 'closeReason', clearable: true,disabled: false},//关闭原因
          // {
          //   type: 'checkbox',
          //   label: this.$t('fundPaymentApply.column.isVirtual'),
          //   prop: 'isVirtual',
          //   clearable: true,
          //   disabled: true,
          // }, //1.虚拟,0非虚拟
          // {
          //   type: 'input',
          //   maxlength: 20,
          //   label: '汇款用途',
          //   prop: 'paymentUsage',
          //   clearable: true,
          //   disabled: false,
          //   required: true,
          // }, //汇款用途
        ];

        if (this.formData?.requestStatus == 'Rejected') {
          list.push({
            type: 'input',
            span: 24,
            maxlength: 600,
            label: '驳回意见',
            prop: 'finalRejection',
            // validator: specialValidate,
            clearable: false,
            disabled: true,
          }); //摘要;
        }

        list = list.concat([
          {
            type: 'checkbox',
            label: '多收款方',
            prop: 'isMoreDeliverer',
            clearable: true,
            disabled:
              this.formData?.settlementBusinessTypeName != '贸易' ||
              this.formData?.settlementBusinessTypeName != '城矿',
          }, //1 是,0否
          {
            type: 'checkbox',
            label: '是否预付',
            prop: 'isPrepay',
            clearable: true,
            disabled:
              !!this.feeInfo.isRelatedInstruction || this.formData?.settlementBusinessType == '03',
            //'1预付,0不预付'
          },
        ]);
        //是否关联供应商发货指令 (0-否,1-是)
        if (
          this.formData?.settlementBusinessType == '01' ||
          this.formData?.settlementBusinessType == '05'
        ) {
          list.push({
            type: 'checkbox',
            label: '是否关联供应商发货指令',
            prop: 'isRelatedInstruction',
            clearable: true,
            disabled: true,
          });
        }
        return list;
      },
    },
    mounted() {
      this.formData.requestPersonNo = this.userInfo.userCode;
      this.formData.requestPersonName = this.userInfo.userName;
      if (this.canEdit && this.userInfo.businessGroup == '多式联运') {
        this.formData.paymentMethod = '02';
        this.formData.settlementBusinessTypeName = '多式联运';
        this.formData.settlementBusinessType = this.dictListMap.businessCategoryPayable.find(
          (item) => item.label == '多式联运'
        )?.value;
        this.$emit('settlementBusinessTypeHandler', this.formData.settlementBusinessType);
      }
    },
    watch: {
      // 监听表单变化
      formData: {
        handler: XEUtils.debounce(function (newValue, oldValue) {
          //当切换付款类别时，客户退款-有合同 需查询收款单位为客户，其他为供应商
          /* if(newValue.paymentType!=oldValue.paymentType && [newValue.paymentType,oldValue.paymentType].indexOf('PT03')!=-1){
              // this.resetPayee();
              this.resetBankInfo();
            } */

          this.$emit('updateForm', this.formData);
          let newPaymentTypeCS = newValue.paymentType
            ? paymentClass.find((it) => it.value == newValue.paymentType).CS
            : '';
          let oldPaymentTypeCS = oldValue.paymentType
            ? paymentClass.find((it) => it.value == oldValue.paymentType).CS
            : '';
          if (oldPaymentTypeCS && newPaymentTypeCS !== oldPaymentTypeCS) {
            this.resetPayee();
            this.resetBankInfo();
          }
          // 原币金额
          this.formData.requestAmountStr =
            this.formData.requestAmount >= 0 ? digitUppercase(this.formData.requestAmount) : '';
          this.formData.requestAccountedAmountStr =
            this.formData.requestAccountedAmount >= 0
              ? digitUppercase(this.formData.requestAccountedAmount)
              : '';
          this.formData.unpaidAmountStr =
            this.formData.unpaidAmount >= 0 ? digitUppercase(this.formData.unpaidAmount) : '';
          this.formData.unpaidAccountedAmountStr =
            this.formData.unpaidAccountedAmount >= 0
              ? digitUppercase(this.formData.unpaidAccountedAmount)
              : '';
          this.formData.requestAccountedAmount = this.replaceZeroStr(
            this.formData.requestAccountedAmount
          );
          this.formData.requestAccountedAmount = this.replaceZeroStr(
            this.formData.requestAccountedAmount
          );
          this.formData.paidAmount = this.replaceZeroStr(newValue.paidAmount);
          this.formData.unpaidAmount = this.replaceZeroStr(newValue.unpaidAmount);
          this.formData.paidAccountedAmount = this.replaceZeroStr(newValue.paidAccountedAmount);
          this.formData.unpaidAccountedAmount = this.replaceZeroStr(newValue.unpaidAccountedAmount);

          if (this.formData.paidAmount >= 0 && this.formData.requestAmount >= 0) {
            if (this.formData.paymentStatus == 'Paid' || this.formData.paymentStatus == 'Part') {
              let digit =
                (Number(this.formData.paidAmount) / Number(this.formData.requestAmount)) * 100;
              this.formData.paymentProportion = digit.toFixed(2);
            }
          }
        }, 100),
        deep: true,
      },
    },
    data() {
      const date = XEUtils.toDateString(new Date(), 'yyyy-MM-dd');
      return {
        paymentTypeList: paymentClass,
        departmentList: [], // 部门列表
        isInsureTypeList: [
          { id: '0', name: '否' },
          { id: '1', name: '是' },
        ],
        editConfig: {},
        tableToolbar: {},
        bankTableLoad: false,
        linkTableLoad: false,
        fileTableLoad: false,
        formData: {
          paymentApplyNumber: '', // 付款申请单号
          requestCompanyCode: '', // 申请单公司代码
          requestCompanyName: '', // 申请单公司名称
          requestDepartmentCode: '', // 申请单部门代码
          requestDepartmentName: '', // 申请单部门名称
          paymentType: '', // 付款类别(字典)
          payeeNo: '', // 收款单位
          payeeName: '', // 收款单位名称
          bankNo: '', // 开户银行
          bankName: '', // 开户银行名 称
          bankAccount: '', // 银行账号
          bankUnionNumber: '', // 联行号
          bankBranch: '', // 开户分行
          paymentMethod: '', // 付款方式(字典)
          requestPersonNo: '', // 申请人编码
          requestPersonName: '', // 申请人名称
          requestAmount: '', // 申请金额原币
          requestAmountStr: '',
          requestAccountedAmount: '', // 申请金额本位币
          currencyCode: '', // 币种编码
          currencyName: '', // 币种名称
          exchangeType: '', // 汇率类型(字典)
          exchangeRate: '', // 汇率
          exchangeRateDate: date, // 汇率日期
          requestStatus: '', // 单据状态
          paidAmount: '', // 已付款金额原币
          unpaidAmount: '', // 未付款金额原币
          requestDate: date, // 申请日期
          gmtCreate: '', //创建日期
          isVirtual: '', // 1.虚拟,0非虚拟
          isPrepay: '', // 1.预付 2.不预付
          paidAccountedAmount: '', // 已付款金额本位币
          unpaidAccountedAmount: '', // 未付款金额本位币
          availableCreditAmount: '', // 可用信用额度
          requestAccountedAmountStr: '',
          unpaidAmountStr: '',
          unpaidAccountedAmountStr: '',
          summary: '', // 摘要
          supplementary: '',
          closeReason: '', // 关闭原因
          paymentUsage: '', // 汇款用途
          paymentStatus: '', //付款状态
          isMoreDeliverer: '', //是否多投送人(0-否,1-是)
          settlementBusinessType: '',
          settlementBusinessTypeName: '', // 业务类型
          finalRejection: '', //驳回意见
          /*    isAdvanceTax: '', // 1代垫,0非代垫
            isLogisticsApprove: '', // 1提交,0不提交
            isReceipt: '', // 1收汇,0非收汇
            isFundReexport: '', // 1转口,0非转口
            isFreeze: '', // 1冻结,0非冻结
            fundAllocationType: '', // 资金调拨类型(字典) */
          isRelatedInstruction: '', //是否关联供应商发货指令 (0-否,1-是)
          //20230214新增字段 story
          //信用证号
          // clCode: '',
          // billNo: '',
          //已付款比例
          paymentProportion: '0',
        }, // 顶部表单的数据
        checkPartner: null, // 查重返回结果
        taxTypeList: [], //发票类型
        partnersBanks: [], // 银行列表
        currency: '',
      };
    },
    methods: {
      handleChange(v, prop) {
        console.log(v, prop, '切换', v[prop]);
        this.formData[prop] = v[prop];
        if (prop == 'requestCompanyCode') {
          this.formData.requestCompanyCode = v[prop];
          this.formData.requestCompanyName = v[prop]
            ? this.companyList.find((it) => it.value == v[prop]).label
            : '';
          this.formData.requestDepartmentCode = '';
          this.formData.requestDepartmentName = '';
          this.departmentList = [];
          this.$emit('resetRowInfo');
          this.resetPayee();
          if (!v[prop]) return;
          this.getdepartmentList(this.formData.requestCompanyCode);
          this.getLedger(this.formData.requestCompanyCode);
        } else if (prop == 'requestDepartmentCode') {
          this.formData.requestDepartmentCode = v[prop];
          this.resetPayee();
          this.formData.requestDepartmentName = v[prop]
            ? this.departmentList.find((it) => it.value == v[prop]).label
            : '';
          // this.getCreditLimitSummary()
        } else if (prop == 'payeeNo') {
          this.resetBankInfo();
          this.$emit('resetRowInfo');
          this.getBankInfo(this.formData.payeeNo, this.formData.requestCompanyCode);
          // this.getCreditLimitSummary()
        } else if (prop == 'currencyCode') {
          this.formData.currencyName =
            this.currencyList.find((i) => i.value === v[prop]) &&
            (this.currencyList.find((i) => i.value === v[prop]).currencyName || '');
          this.selectTaxRate();
        } else if (prop == 'exchangeRateDate' || prop == 'exchangeType') {
          this.selectTaxRate();
        } else if (prop == 'paymentType') {
          this.formData.isVirtual = v[prop] == 'PT06';
          if (
            this.userInfo.businessGroup == '多式联运' &&
            this.formData.settlementBusinessTypeName == '多式联运'
          ) {
            // 付款方式默认银行转账
            this.formData.paymentMethod = '02';
          } else {
            this.formData.paymentMethod = '';
          }
          this.$emit('clearBillCertList', 0);

          // this.formData.clCode = '';
          // this.formData.billNo = '';
          let paymentObj = this.paymentTypeList.find(
            (item) => item.value == this.formData.paymentType
          );
          this.formData.paymentUsage = paymentObj ? paymentObj.paymentUsage : '';
        } else if (prop == 'bankAccount') {
          if (v[prop]) {
            const bankInfo = this.partnersBanks.find((i) => i.value === v[prop]);
            this.selectBank(bankInfo);
          } else {
            this.resetBankInfo();
          }
        } else if (prop == 'isPrepay') {
          if (this.formData.isPrepay && this.getPayapplyLine().length > 0) {
            this.$confirmAction('提示', '切换预付将重置行信息，请确认')
              .then(() => {
                this.$emit('resetRowInfo');
              })
              .catch(() => {
                this.formData.isPrepay = false;
              });
          }
        } else if (prop == 'settlementBusinessType') {
          this.formData.settlementBusinessTypeName = this.dictListMap.businessCategoryPayable.find(
            (item) => item.value == v[prop]
          )?.label;
          console.log(this.formData.settlementBusinessType);
          this.$emit('settlementBusinessTypeHandler', v[prop]);
        } else if (prop == 'paymentMethod') {
          if (
            !this.formData.paymentMethod ||
            (this.formData.paymentMethod == '' ||
              [('016', '015')].indexOf(this.formData.paymentMethod)) == -1
          ) {
            // this.formData.clCode = '';
            this.$emit('clearBillCertList', 2);
          }

          if (
            !this.formData.paymentMethod ||
            (this.formData.paymentMethod == '' ||
              [('013', '012')].indexOf(this.formData.paymentMethod)) == -1
          ) {
            // this.formData.billNo = '';
            this.$emit('clearBillCertList', 1);
          }
        } else if (prop == 'clCode') {
          // this.formData.clCode = v[prop][0].clCode;
        } else if (prop == 'billNo') {
          // this.formData.billNo = v[prop][0].billCode;
        }
      },
      // 重置付款单位信息
      resetPayee() {
        this.formData.payeeNo = '';
        this.formData.payeeName = '';
      },
      // 重置银行信息
      resetBankInfo() {
        this.formData.bankNo = '';
        this.formData.bankAccount = '';
        this.formData.bankUnionNumber = '';
        this.formData.bankBranch = '';
      },
      // 获取银行信息
      getBankInfo(partnerCode) {
        if (!partnerCode) return;
        this.$axios
          .get(PAYMENT_API.GET_PARTER_BANK, {
            partnerCode,
            companyCode: this.formData?.requestCompanyCode,
            // departmentCode: this.formData?.requestDepartmentCode,
          })
          .then((res) => {
            if (res.data.code === 0) {
              this.partnersBanks = res.data.data.map((it) => {
                it['value'] = it.bankAccount;
                it['label'] = it.bankName + '-' + it.bankAccount;
                return it;
              });

              if (res.data.data != null && res.data.data.length == 1) {
                let tempData = res.data.data[0];
                this.selectBank(tempData);
              }
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
      },
      // 选择银行信息
      selectBank(tempData) {
        this.formData.bankNo = tempData.bankCode;
        this.formData.bankName = tempData.bankName;
        this.formData.bankAccount = tempData.bankAccount;
        this.formData.bankUnionNumber = tempData.associatedLineNumber;
        this.formData.bankBranch = tempData.accountBankBranch;
      },
      // 获取公司对应本币位
      getLedger(companyCode) {
        this.$baseRequest.getLedger(companyCode).then((res) => {
          if (res.length > 0) {
            //如果换公司，则币种都默认变化
            this.formData.companyCurrencyCode = res[0].currencyCode;
            this.formData.companyCurrencyName = res[0].currencyName;
            //默认汇率类型
            // this.formData.exchangeType = res[0].defaultExchangeType
            //【ID1001693】汇率当前处理规则
            //收付款单据的汇率类型，默认为用户类型。值取当日的汇率值。
            this.formData.exchangeType = 'Cooperate';
            this.formData.currencyCode = res[0].currencyCode;
            this.formData.currencyName = res[0].currencyName;
            this.selectTaxRate();
          } else {
            //没有查询到公司账套
            this.formData.companyCurrencyCode = null;
            this.formData.exchangeType = null;
            this.formData.exchangeRate = null;
            this.$alert(this.$t('addInvoice.warnInfo.ledgerInfo'));
          }
        });
      },
      //获取汇率
      getRate() {
        if (this.formData.currencyCode || this.formData.companyCurrencyCode) {
          // const { tenantCode, companyCode, departmentCode } = this.userInfo;
          const params = {
            fromCurrencyCode: this.formData.currencyCode,
            toCurrencyCode: this.formData.companyCurrencyCode,
            exchangeDate: this.formData.exchangeRateDate,
            exchangeType: this.formData.exchangeType,
          };
          this.$baseRequest.getRate(params).then((res) => {
            if (res) {
              this.formData.exchangeRate = res.positiveRate;
            } else {
              this.formData.exchangeRate = null;
              this.$message({ showClose: true, message: '缺少对应汇率，请维护', type: 'error' });
            }
          });
        }
      },
      // 获取发票编号
      getInvoiceCodes() {
        const { requestCompanyCode, payeeNo } = this.feeInfo;
        if (!requestCompanyCode || !payeeNo) return;
        this.$axios
          .post(PAYMENT_API.INVOICE_CODES, {
            payableInvoiceCompanyCode: requestCompanyCode,
            invoiceUnitNo: payeeNo,
            isApplyRequest: 1,
          })
          .then((res) => {
            if (res.data.code === 0) {
              this.$emit('getInvoiceCodes', res.data.data.records);
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
      },
      // 获取部门
      async getdepartmentList(companyCode) {
        // TODO 公司代码字段未定
        this.departmentList = [];
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          personCompanyCode: companyCode,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          let personDepartmentInfo = selectStatus.data.data.personDepartmentInfo || [];
          if (personDepartmentInfo[0]) {
            this.departmentList = personDepartmentInfo.map((it) => {
              return { value: it.personDepartmentCode, label: it.personDepartmentName };
            });
          }
        }
      },
      // 收款单位查询条件
      getPayeeData() {
        const { adminFlag } = this.userInfo;
        let params = {
          // 1039 根据主数据查询结果看，付款单位的取值范围错误
          // 钉钉12/12 孙君炜：目前还没有细分权限，先基础的吧
          partnerTypes: '',
          adminFlag,
          companyCode: this.formData.requestCompanyCode,
          departmentCode: this.formData.requestDepartmentCode,
          requestStatus: 'ZT03',
        };
        //付款类别为资金调拨-同户名调拨时，收款单位为与公司相同的单位
        if (this.formData.paymentType == 'PT08')
          params.partnerZhName = this.formData.requestCompanyName;
        if (this.formData.sourceType == 'INVOICE') delete params.partnerDepartmentCode;
        return params;
      },
      //币种选择formData
      selectCurrency(v) {
        this.formData.currencyName = this.currencyList.find((i) => i.value === v).currencyName;
        this.selectTaxRate();
      },
      // 汇率值获取
      selectTaxRate() {
        // let taxRate;
        if (
          this.formData.companyCurrencyCode &&
          this.formData.currencyCode &&
          this.formData.companyCurrencyCode === this.formData.currencyCode
        ) {
          this.formData.exchangeRate = 1;
        } else if (this.formData.companyCurrencyCode && this.formData.currencyCode) {
          this.getRate();
        }
      },
      // 获取汇率
      selectExchangeType(fromCurrencyCode) {
        return this.$axios.post(API.GET_CURRENCY_EXCHANGE, { fromCurrencyCode }).then((res) => {
          if (res.data.code !== 0) {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      // 获取信用额度列表
      getCreditLimitSummary() {
        if (this.formData.requestDepartmentCode && this.formData.payeeNo) {
          const query = {
            businessDepartmentCode: this.formData.requestDepartmentCode,
            partnerCode: this.formData.payeeNo,
          };
          this.$axios.post(PAYMENT_API.GET_AVAILABLE_AMOUNT, query).then((res) => {
            this.load = false;
            if (0 == res.data.code) {
              this.formData.availableCreditAmount = res.data.data;
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
        }
      },
    },
  };
</script>
